/**
 * Shared Accordion itemClasses for log cards
 * Ensures consistent styling across all log card components
 */
export const logCardItemClasses = {
  base: 'mb-0 rounded-lg border border-outline bg-surface',
  trigger: 'px-4 py-3 bg-surface-dim hover:bg-surface-hover rounded-t-lg',
  content: 'p-4'
};

export type LogCardAccordionItemClasses = Partial<typeof logCardItemClasses>;

/**
 * HeroUI Accordion root applies `px-2` by default; `px-0` loses in tailwind-merge — use important.
 */
export const traceDetailAccordionRootClassName = '!px-0';

/**
 * HeroUI Accordion itemClasses for trace detail sections (Output, Logs, Annotation insights tab).
 * Keeps the annotation-insights tab accordions visually aligned with the output-details tab.
 */
export const traceDetailSectionAccordionItemClasses = {
  trigger: 'px-4 py-3 bg-surface-dim hover:bg-surface-hover rounded-t-lg',
  titleWrapper: 'px-0'
} as const;

/**
 * Neutral empty / helper copy inside trace detail accordions (logs, dataset annotations, insights hints).
 * Use {@link traceAccordionEmptyStateTextClassName} on the inner paragraph.
 */
export const traceAccordionEmptyStateRootClassName =
  'flex flex-col items-center justify-center px-3 py-4 text-center';

export const traceAccordionEmptyStateTextClassName =
  'max-w-prose text-sm leading-relaxed text-on-surface-variant';

/**
 * Inline status (loading) or alerts (error, not found) inside the same accordion panels — shared vertical rhythm.
 */
export const traceAccordionPanelNoticeRootClassName = 'px-3 py-4';

export const traceAccordionPanelLoadingRowClassName =
  'flex items-center justify-center gap-2 px-3 py-4 text-sm text-on-surface-variant';

/**
 * Shared Accordion itemClasses for nested accordions (e.g., in GuardrailCard, ToolCallCard)
 */
export const nestedAccordionItemClasses = {
  base: 'mb-3 last:mb-0',
  trigger:
    'px-3 py-2 bg-surface hover:bg-surface-hover rounded-md border border-outline',
  content: 'mt-2'
};

/**
 * List of expandable rows inside a trace-detail section (e.g. Eval Logs).
 * Matches {@link logCardItemClasses} chrome so it aligns with LogCard-based trace rows.
 */
export const traceDetailEvalLogListItemClasses = {
  ...logCardItemClasses,
  base: 'mb-2 last:mb-0 rounded-lg border border-outline bg-surface'
} as const;
